import { render, staticRenderFns } from "./ModalAddNewPersonalizationItem.vue?vue&type=template&id=3f03993f&scoped=true"
import script from "./ModalAddNewPersonalizationItem.vue?vue&type=script&lang=js"
export * from "./ModalAddNewPersonalizationItem.vue?vue&type=script&lang=js"
import style0 from "./ModalAddNewPersonalizationItem.vue?vue&type=style&index=0&id=3f03993f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f03993f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f03993f')) {
      api.createRecord('3f03993f', component.options)
    } else {
      api.reload('3f03993f', component.options)
    }
    module.hot.accept("./ModalAddNewPersonalizationItem.vue?vue&type=template&id=3f03993f&scoped=true", function () {
      api.rerender('3f03993f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/ModalAddNewPersonalizationItem.vue"
export default component.exports